import React from 'react';
import { Helmet } from 'react-helmet-async';

const Coder = () => {
  return (
    <>
      <Helmet>
        <title>Become a Coder | Slávka Vavřinová</title>
        <meta
          name="description"
          content="Doporučené knihy, kurzy a zdroje od Slávky Vavřinové pro ty, kdo se chtějí naučit programovat."
        />
        <link rel="canonical" href="https://www.slavkavav.cz/coaching/coder" />
      </Helmet>
      <div className="main">
        <h2>Become a Coder</h2>
        <h3>Books</h3>
        <ul>
          <li>UX for Beginners</li>
          <li>The Good Designer Knows It All!</li>
          <li>Sharp as a Razor</li>
          <li>Web Copywriting for Self-Learners</li>
          <li>Copywriting – Write Texts That Sell</li>
          <li>
            Sprint: How to Solve Big Problems and Test New Ideas in Just Five
            Days
          </li>
          <li>Mini-books by Austin Kleon</li>
          <li>Influence: The Psychology of Persuasion</li>
        </ul>
        <h3>Colors</h3>
        <ul>
          <li>
            <a href="https://coolors.co/" target="_blank" rel="noreferrer">
              coolors.co
            </a>
          </li>
          <li>
            <a
              href="https://color.adobe.com/cs/create/color-wheel"
              target="_blank"
              rel="noreferrer"
            >
              Colors by Adobe
            </a>
          </li>
          <li>
            <a
              href="https://paletton.com/#uid=1000u0kllllaFw0g0qFqFg0w0aF"
              target="_blank"
              rel="noreferrer"
            >
              Paletton
            </a>
          </li>
          <li>
            <a
              href="https://htmlcolorcodes.com/"
              target="_blank"
              rel="noreferrer"
            >
              HTML COLOR CODES
            </a>
          </li>
          <li>
            <a
              href="https://www.w3schools.com/cssref/css_colors.asp"
              target="_blank"
              rel="noreferrer"
            >
              Named colors
            </a>{' '}
            {' '}or{' '}{' '}
            <a
              href="https://developer.mozilla.org/en-US/docs/Web/CSS/color_value"
              target="_blank"
              rel="noreferrer"
            >
              here.
            </a>
          </li>
        </ul>
        <h3>Contrast</h3>
        <ul>
          <li>
            <a
              href="https://contrast-ratio.com/"
              target="_blank"
              rel="noreferrer"
            >
              Contrast ratio
            </a>
          </li>
          <li>
            <a
              href="https://colourcontrast.cc/"
              target="_blank"
              rel="noreferrer"
            >
              Colour Contrast Checker
            </a>
          </li>
          <li>
            <a
              href="https://contrastchecker.com/"
              target="_blank"
              rel="noreferrer"
            >
              CONTRAST CHECKER
            </a>
          </li>
          <li>
            <a
              href="https://webaim.org/resources/contrastchecker/"
              target="_blank"
              rel="noreferrer"
            >
              WebAIM
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.accessibility.auditor&hl=en"
              target="_blank"
              rel="noreferrer"
            >
              Accessibility Scanner app
            </a>
          </li>
          <li>
            <a
              href="http://www.color-blindness.com/coblis-color-blindness-simulator/"
              target="_blank"
              rel="noreferrer"
            >
              Color Blindness Simulator
            </a>{' '}
            Color Blindness Simulator
          </li>
        </ul>
        <h3>Inspiration</h3>
        <ul>
          <li>
            <a href="https://www.behance.net/" target="_blank" rel="noreferrer">
              Behence
            </a>
          </li>
          <li>
            <a href="https://dribbble.com/" target="_blank" rel="noreferrer">
              Dribbble
            </a>{' '}
            Note: designs here are not tested. Design inspiration only.
          </li>
          <li>
            <a href="https://www.behance.net/" target="_blank" rel="noreferrer">
              Behence
            </a>
          </li>
          <li>
            <a
              href="https://www.deviantart.com/"
              target="_blank"
              rel="noreferrer"
            >
              Deviant art
            </a>
          </li>
          <li>
            <a
              href="http://www.jinudy.cz/clanky/psychologie-barev/"
              target="_blank"
              rel="noreferrer"
            >
              Color Psychology
            </a>
          </li>
        </ul>
        <h3>Design systems</h3>
        <ul>
          <li>
            <a
              href="https://material.io/resources"
              target="_blank"
              rel="noreferrer"
            >
              MATERIAL DESIGN
            </a>
          </li>
          <li>
            <a
              href="https://polaris.shopify.com/content/voice-and-tone"
              target="_blank"
              rel="noreferrer"
            >
              Polaris (Shopify)
            </a>
          </li>
          <li>
            <a
              href="https://airbnb.design/building-a-visual-language/"
              target="_blank"
              rel="noreferrer"
            >
              Airbnb
            </a>
          </li>
          <li>
            <a
              href="https://developer.apple.com/design/"
              target="_blank"
              rel="noreferrer"
            >
              Apple
            </a>
          </li>
          <li>
            <a
              href="https://www.microsoft.com/design/fluent/#/"
              target="_blank"
              rel="noreferrer"
            >
              Microsoft Design
            </a>
          </li>

          <li>
            <a
              href="https://www.carbondesignsystem.com/"
              target="_blank"
              rel="noreferrer"
            >
              Carbon Design System Search (IBM)
            </a>
          </li>
          <li>
            <a
              href="https://orbit.kiwi/components/"
              target="_blank"
              rel="noreferrer"
            >
              Orbit (Kiwi)
            </a>
          </li>
          <li>
            <a
              href="https://designsystem.digital.gov/"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              U.S. Web Design System (USWDS)
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Coder;
